import styled from '@emotion/styled';
import { BreakpointsEnum } from '../../helpers/breakpoints';

export const ActionBarStyled = styled.div`
    display: flex;
    flex-flow: wrap;
    padding: 16px;
    margin: 5px 15px;
    border-radius: 6px;
    border: 2px solid ${({ theme }) => theme.actionBar.borderColor};
    background-color: ${({ theme }) => theme.actionBar.backgroundColor};
    @media (min-width: ${BreakpointsEnum.md}) {
        padding: 24px;
        margin: 0 0 10px 0;
    }
`;
